export const getHostname = () => {
  return window.location.hostname;
};